import { IconBaseProps, IconType } from "@/types/icon";

export const ChevronDownOutlineIcon: IconType = ({
  size = 24,
  color = "text-gray-800",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M7.69622 10.044L7.69628 10.0441C7.77575 10.1196 7.88872 10.1663 8.01153 10.1663L7.69622 10.044ZM7.69622 10.044L3.96289 6.49572L3.96294 6.49566M7.69622 10.044L3.96294 6.49566M3.96294 6.49566L3.95655 6.4898M3.96294 6.49566L3.95655 6.4898M3.95655 6.4898C3.91618 6.45274 3.88547 6.40981 3.86489 6.36427C3.84435 6.31881 3.83395 6.27094 3.83351 6.22322C3.83307 6.1755 3.8426 6.12753 3.86225 6.08187C3.88194 6.03614 3.91176 5.99285 3.95132 5.95525C3.99094 5.9176 4.03944 5.88653 4.09462 5.86507C4.14983 5.8436 4.2098 5.83252 4.27081 5.83302C4.33182 5.83353 4.39151 5.8456 4.44622 5.86793C4.50088 5.89025 4.54867 5.92203 4.58746 5.9602L4.58741 5.96026M3.95655 6.4898L4.58741 5.96026M4.58741 5.96026L4.59371 5.96624M4.58741 5.96026L4.59371 5.96624M4.59371 5.96624L7.66717 8.88737L8.01163 9.21475M4.59371 5.96624L8.01163 9.21475M8.01163 9.21475L8.35609 8.88737M8.01163 9.21475L8.35609 8.88737M8.35609 8.88737L11.4258 5.96982C11.5059 5.89754 11.6173 5.85383 11.7375 5.85483C11.8589 5.85583 11.9704 5.90232 12.049 5.97705C12.1268 6.05099 12.166 6.14555 12.1668 6.23875C12.1677 6.33089 12.1311 6.42475 12.0566 6.4993L8.32704 10.044L8.32699 10.0441M8.35609 8.88737L8.32699 10.0441M8.32699 10.0441C8.24751 10.1196 8.13454 10.1663 8.01173 10.1663L8.32699 10.0441Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};
